import React from "react";
import { Overlay, OverlaySpinner, OverlayText } from "./styles";

/**
 * Full-screen loading overlay. Renders nothing when inactive.
 */
const LoadingOverlay = ({ active = false, spinner = true, text, children }) => {
  return (
    <>
      {active && (
        <Overlay role="status" aria-live="polite">
          {spinner && <OverlaySpinner aria-hidden="true" />}
          {text && <OverlayText>{text}</OverlayText>}
        </Overlay>
      )}
      {children}
    </>
  );
};

export default LoadingOverlay;
